import dayjs from 'dayjs'

const gift = {
  giftTermClass: 'select-gift-term',
  giftCloseTermButton: '[data-terms-agree-close]',
  giftTermButton: '[data-terms-agree-button]',
  giftViewClass: 'select-gift-setting',
  giftOpenButton: '.product-add-gift',
  giftCloseButton: '.btn-close--all-in-gift',
  viewAgeCheck: 'is-age-confirm',
  viewConfirmModeBuy: 'is-confirm-buy',
  viewConfirmModeGift: 'is-confirm-gift',
  errorConfirmMode: 'is-age-confirm-error',
}

let cookieAgeConfirm = false

/**
 * PC表示時デザイン調整
 */
const optionPcView = (productCartButtons) => {
  const body = document.querySelector('body')
  if (window.matchMedia('(min-width: 768px)').matches && productCartButtons.length > 0) {
    const productMenu = document.querySelector('[data-product-menu]')

    productCartButtons.forEach((button) => {
      if (!productMenu.classList.contains('product-menu-add')) {
        if (button.getAttribute('data-product-menu-button') === 'selectoptions') {
          button.click()
          document.querySelector('.product-menu-slideout').blur()
        }
      }
    })
  }
}

/**
 * 商品詳細: ギフト設定
 */
const productGiftSetting = () => {
  const body = document.querySelector('body')
  const productCartButtons = Array.from(document.querySelectorAll('[data-product-menu-button]'))
  optionPcView(productCartButtons)

  if (productCartButtons.length > 0) {
    ageConfirmSetting()
  }

  window.addEventListener('resize', () => optionPcView(productCartButtons))

  /**
   * 0.5秒おきに document.querySelectorAll('.sns-gift-product-container .chakra-container') が取得できるまで待機、20秒経っても取得できない場合は処理を終了。
   */
  let count = 0
  const timer = setInterval(() => {
    if (
      Array.from(document.querySelectorAll('.sns-gift-product-container > div > chakra-scope'))
        .length > 0
    ) {
      clearInterval(timer)
      initGiftSetting()
      if (!body.classList.contains('is-sold')) {
        body.classList.add('has-gift-setting')
      }
    } else {
      count++
      if (count > 40) {
        clearInterval(timer)
      }
    }
  }, 500)

  Array.from(document.querySelectorAll('[data-option-value]')).forEach((option) => {
    if (option.getAttribute('data-option-value') === 'Title') {
      body.classList.add('no-option')
    }
  })
}

/**
 * ギフト設定開始アクション設定
 */
const initGiftSetting = () => {
  const body = document.querySelector('body')
  const giftOpenButton = document.querySelector(gift.giftOpenButton)
  const closeGiftSettingButton = document.querySelector(gift.giftCloseButton)
  const closeGiftTermsButton = Array.from(document.querySelectorAll(gift.giftCloseTermButton))
  const ageConfirm = document.querySelector('[data-age-confirm]')

  const giftHeader = document.querySelector(
    '.sns-gift-product-container chakra-scope > div:first-child > div:first-child',
  )

  const container = document.querySelector('.sns-gift-product-container')
  let closeBg = document.createElement('div')
  closeBg.classList.add('sns-gift-product-container--bg')
  closeBg.addEventListener('click', () => {
    closeGiftSettingButton.click()
  })
  container.prepend(closeBg)

  /**
   * ギフト設定表示クラス付与 && ギフト設定チェックボックスをクリック処理
   */
  if (giftOpenButton) {
    addTermsAgreement()

    giftOpenButton.addEventListener('click', () => {
      cookieAgeConfirm = Boolean(Cookies.get('ageConfirm')) || false

      body.classList.remove(gift.giftViewClass)
      if (ageConfirm && !cookieAgeConfirm) {
        body.classList.add(gift.viewAgeCheck, gift.viewConfirmModeGift)
      } else {
        body.classList.add(gift.giftTermClass)
      }
    })

    closeGiftTermsButton.forEach((button) => {
      button.addEventListener('click', () => {
        body.classList.remove(gift.giftTermClass)
      })
    })

    /**
     * ギフト設定非表示
     */
    closeGiftSettingButton.addEventListener('click', () => {
      body.classList.remove(gift.giftViewClass)
    })
  }
}

const addTermsAgreement = () => {
  const body = document.querySelector('body')
  const closeGiftTermsButton = Array.from(document.querySelectorAll(gift.giftTermButton))

  body.classList.remove(gift.giftViewClass)

  closeGiftTermsButton.forEach((button) => {
    button.addEventListener('click', () => {
      body.classList.remove(gift.giftTermClass)
      body.classList.add(gift.giftViewClass)
    })
  })
}

/**
 * 年齢確認モーダル設定
 */
const ageConfirmSetting = () => {
  const body = document.querySelector('body')
  const ageConfirm = document.querySelector('[data-age-confirm]')

  if (ageConfirm) {
    const birth = document.querySelector('[name="birth_date"]')
    const age = document.querySelector('[name="age"]')
    const confirmSubmit = document.querySelector('[data-age-confirm-anser]')

    birth.addEventListener('change', (e) => {
      e.preventDefault()
      changeInput()
    })

    age.addEventListener('change', (e) => {
      e.preventDefault()
      changeInput()
    })

    const changeInput = () => {
      confirmSubmit.disabled = birth.value === '' || age.value === ''
      body.classList.remove(gift.errorConfirmMode)
    }

    // モーダル クローズ処理
    const ageConfirmCloses = Array.from(document.querySelectorAll('[data-age-confirm-close]'))
    ageConfirmCloses.forEach((close) => {
      close.addEventListener('click', (e) => ageConfirmClose())
    })

    confirmSubmit.addEventListener('click', (e) => {
      e.preventDefault()
      if (!ageConfirmCheck()) {
        return false
      }
      if (body.classList.contains(gift.viewConfirmModeBuy)) {
        // 購入処理用の隠しボタンをクリック処理
        const submit = document.querySelector('[data-age-confirm-submit]')
        submit.click()
      } else if (body.classList.contains(gift.viewConfirmModeGift)) {
        // ギフト設定に遷移
        body.classList.add(gift.giftTermClass)
      }
      ageConfirmClose()
      confirmSubmit.disabled = true
    })
  }
}

/**
 * 年齢確認モーダル クローズ処理
 * @returns {void}
 */
const ageConfirmClose = () => {
  const body = document.querySelector('body')
  const input = document.querySelector('[name="birth_date"]')
  body.classList.remove(
    gift.viewAgeCheck,
    gift.viewConfirmModeBuy,
    gift.viewConfirmModeGift,
    gift.errorConfirmMode,
  )
  input.value = ''
}

/**
 * dayjs を使用してbirth_dateの生年月日が20歳未満の場合 or ageの入力内容が20以下の場合 falseを返す
 * @returns {boolean}
 */
const ageConfirmCheck = () => {
  const body = document.querySelector('body')
  const birth = document.querySelector('[name="birth_date"]')
  const age = document.querySelector('[name="age"]')

  if (birth.value === '' || age.value === '') return false

  if (dayjs().diff(dayjs(birth.value), 'year') < 20 || age.value < 20) {
    Cookies.remove('ageConfirm')
    body.classList.add(gift.errorConfirmMode)
    return false
  }

  Cookies.set('ageConfirm', true, { expires: 1, path: '/' })

  return true
}

export { productGiftSetting, ageConfirmCheck, ageConfirmClose }
